import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import SmileArc from "@/components/SmileArc";
import { useCart } from "@/context/CartContext";

const EASE = [0.16, 1, 0.3, 1];

export default function ThanksPage() {
  const navigate = useNavigate();
  const { clear } = useCart();

  useEffect(() => {
    clear();
  }, []);

  return (
    <main
      data-testid="thanks-page"
      className="flex min-h-[85vh] flex-col items-center justify-center px-6 pb-24 pt-28 text-center"
    >
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="text-xs uppercase tracking-[0.35em] text-ember"
      >
        Order confirmed
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.35, ease: EASE }}
        className="mt-6 font-serif text-6xl font-medium tracking-tight text-ink md:text-8xl"
      >
        Thank you.
      </motion.h1>
      <SmileArc className="mt-2 w-52 md:w-72" delay={0.8} strokeWidth={15} />
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.1, ease: EASE }}
        data-testid="thanks-message"
        className="mt-8 max-w-md text-base leading-relaxed text-smoke"
      >
        Your goods are being packed with care. A confirmation email is on its
        way — we hope your new everyday things make every day a little easier.
      </motion.p>
      <motion.button
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.3, ease: EASE }}
        data-testid="thanks-continue"
        onClick={() => navigate("/#shop")}
        className="group mt-10 inline-flex items-center gap-3 border border-ink px-8 py-4 text-xs uppercase tracking-[0.25em] text-ink transition-colors duration-500 hover:border-ember hover:bg-ember"
      >
        Keep browsing
        <ArrowRight
          className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-1"
          strokeWidth={1.5}
        />
      </motion.button>
    </main>
  );
}
